import { useMemo } from 'react';

import LinkBankAccount from './LinkOpenBankingRevamp/LinkBankAccount';
import { useGetContext } from '../../../../api/lendingApi/lendingApiQueries';
import { TOfferDataRequirement } from '../../../../types';
import { getLinkedBankAccountDetails } from '../../OpenBanking/trueLayer.helpers';

type TProps = {
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'];
  isActive: boolean;
  isError?: boolean;
  onRequestUpload: () => void;
  showDirectUpload?: boolean;
};

const BankStatements = ({
  resolutionMethods,
  isActive,
  onRequestUpload,
  showDirectUpload,
}: TProps) => {
  const { context } = useGetContext();

  const linkedBankAccount = useMemo(() => {
    if (!resolutionMethods || !context) return undefined;
    return getLinkedBankAccountDetails(resolutionMethods, context);
  }, [resolutionMethods, context]);

  return (
    <LinkBankAccount
      linkedBankAccount={linkedBankAccount}
      isActive={isActive}
      onRequestUpload={onRequestUpload}
      showDirectUpload={showDirectUpload}
    />
  );
};

export default BankStatements;
